<div class="upload-events" [class.text-disabled]="!toggles.manualEvents">
    <div class="panel relative">
        <div class="panel-header">
            <h1>Import events from excel</h1>
            <upgrade-button [show]="!toggles.manualEvents"
                            [css]="'upgrade-btn'"></upgrade-button>
        </div>

        <div *ngIf="step===0" class="upload-events-tips">
            <strong>You can upload events from an excel file</strong>
            <p>Please make sure your excel file contains the following columns: <strong>Title</strong>, <strong>Time</strong>, <strong>Timezone</strong>, <strong>Address</strong>, <strong>Host</strong>, and make sure these columns have values</p>
            <p>Besides, you can also add more fields, e.g., <strong>Description</strong>, <strong>HostLink</strong>, <strong>Image</strong>, <strong>EventLink</strong> and <strong>TicketUrl</strong></p>
            <p>You can view the example <a *ngIf="toggles.manualEvents" [href]="uploadCsvEventsExample">here</a></p>
            <ig-file-selector [disabled]="!toggles.manualEvents" (onRead)="showCsvContent($event)"></ig-file-selector>
        </div>

        <div *ngIf="step===1" class="event-table">
            <div header>
                <div field *ngFor="let title of header;let i = index;" [class.skipped]="title.isSkipped">
                    <p title>{{title.title}}</p>
                    <p unmatched *ngIf="!title.isMatched">(unmatched column)</p>
                    <p *ngIf="!title.isSkipped">
                        <span #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="actionMenu"
                              (mousedown)="beforeMenuOpen(title)">Edit
                        </span>
                        <span *ngIf="!title.isMatched">·</span><span
                            *ngIf="!title.isMatched"
                            (click)="toggleSkip(i)">Skip
                        </span>
                    </p>
                    <p *ngIf="title.isSkipped" (click)="toggleSkip(i)" class="cancel-skip">Cancel</p>
                    <p matchedtitle>{{title.matchedTo}}</p>
                </div>
            </div>
            <div contentheader *ngFor="let record of content;let i = index;">
                <div contentfield *ngFor="let field of record;let j = index" [class.skipped]="header[j].isSkipped">
                    <span>{{field}}</span></div>
            </div>
        </div>

        <ng-container *ngIf="step===2">
            <span *ngIf="content.length!==newEvents.length">After removing duplicates, y</span><span *ngIf="content.length===newEvents.length">Y</span>ou are adding {{newEvents.length}} events. Do you want these events to be added as approved events or
            unapproved events?
            <mat-radio-group class="upload-events-matching-mat-menu"
                             [(ngModel)]="isApproved">
                <mat-radio-button [value]="true">
                    Approved
                </mat-radio-button>
                <mat-radio-button [value]="false">
                    Unapproved
                </mat-radio-button>
            </mat-radio-group>
        </ng-container>

        <div class="result-wrap" *ngIf="step===3">
            <div *ngIf="result.saved.length"><mat-icon style="color: green">check</mat-icon>{{result.saved.length}} events saved successfully</div>
            <div *ngIf="result.updated.length"><mat-icon style="color: green">cached</mat-icon>{{result.updated.length}} events updated</div>
            <div *ngIf="result.notSaved.length"><mat-icon style="color: red">close</mat-icon>{{result.notSaved.length}} events not saved due to unknown reason</div>
        </div>

        <div *ngIf="step>0" class="btn-group">
            <ig-button *ngIf="step===1" size="md" (trigger)="getEvents()">Next</ig-button>
            <ig-button *ngIf="step===1" size="md" back (trigger)="step=0">Cancel</ig-button>

            <ig-button *ngIf="step===2" size="md" [isAsync]="true" (trigger)="saveEvents($event)">Save Events</ig-button>
            <ig-button *ngIf="step===2" size="md" back (trigger)="step=step-1">Back</ig-button>

            <ig-button *ngIf="step===3" size="md" (trigger)="step=0">OK</ig-button>
        </div>
    </div>

    <mat-menu [yPosition]="'below'" #actionMenu="matMenu">
        <mat-checkbox *ngFor="let header of matchHeader;let i = index" class="upload-events-matching-mat-menu"
                      [class.isMatched]="header.isDisabled"
                      matTooltip="{{(header.isDisabled)?'this field is matched, you need to cancel the match on that column before matching it to another field':header.field}}"
                      [(ngModel)]="header.isChecked" (change)="toggleMatch(header)" [disabled]="header.isDisabled"
                      (click)="matchItemClick($event)">{{header.field}}
        </mat-checkbox>
    </mat-menu>
</div>



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/upload.events/upload.events.component.html